import React from 'react';
import "../../styles/skill-development/main.css";

const Main = () => {
    return (
        <div id='skillDevelopmentMain'>
            <section className="nep-main-section">
                <div className="container">
                    <div>
                        <h2 className="my-heading">Skill Development Courses</h2>
                    </div>
                    <div className="table-div">
                        <table>
                            <thead>
                                <tr>
                                    <th>&nbsp;</th>
                                    <th className="text-start">Name of Subject</th>
                                    <th>Download</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td style={{ textAlign: "center" }}>1</td>
                                    <td>Skill development courses (Certificate course in Computer)</td>
                                    <td style={{ textAlign: "center" }} align="center" valign="middle">
                                        <button className="btn btn-primary btn-download">
                                            <a
                                                className=" float-none"
                                                href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/syllabus-nep/Certi-Computer-Botany.pdf"
                                                target="_blank"
                                                rel="noreferrer"
                                            >
                                                Download
                                            </a>
                                        </button>
                                    </td>
                                </tr>
                                <tr>
                                    <td style={{ textAlign: "center" }}>2</td>
                                    <td>Skill development papers (Mushroom Cultivation )</td>
                                    <td style={{ textAlign: "center" }} align="center" valign="middle">
                                        <button className="btn btn-primary btn-download">
                                            <a
                                                className=" float-none"
                                                href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/syllabus-nep/Botany-Skill-Development-papers.pdf"
                                                target="_blank"
                                                rel="noreferrer"
                                            >
                                                Download
                                            </a>
                                        </button>
                                    </td>
                                </tr>
                                <tr>
                                    <td style={{ textAlign: "center" }}>3</td>
                                    <td>
                                        Skill development course (Principles and Practice of Banking)
                                    </td>
                                    <td style={{ textAlign: "center" }} align="center" valign="middle">
                                        <button className="btn btn-primary btn-download">
                                            <a
                                                className=" float-none"
                                                href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/syllabus-nep/Principles-Practice-Banking-Economics.pdf"
                                                target="_blank"
                                                rel="noreferrer"
                                            >
                                                Download
                                            </a>
                                        </button>
                                    </td>
                                </tr>
                                <tr>
                                    <td style={{ textAlign: "center" }}>4</td>
                                    <td>Skill development course (Basic Communicative English)</td>
                                    <td style={{ textAlign: "center" }} align="center" valign="middle">
                                        <button className="btn btn-primary btn-download">
                                            <a
                                                className=" float-none"
                                                href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/syllabus-nep/skill-dov-course-English.pdf"
                                                target="_blank"
                                                rel="noreferrer"
                                            >
                                                Download
                                            </a>
                                        </button>
                                    </td>
                                </tr>
                                <tr>
                                    <td style={{ textAlign: "center" }}>5</td>
                                    <td>
                                        Skill development course (Organic Farming and Sustainable
                                        Agricultural Practices)
                                    </td>
                                    <td style={{ textAlign: "center" }} align="center" valign="middle">
                                        <button className="btn btn-primary btn-download">
                                            <a
                                                className=" float-none"
                                                href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/syllabus-nep/Orga-Farm-Sust-Agri-Practi-Geography.pdf"
                                                target="_blank"
                                                rel="noreferrer"
                                            >
                                                Download
                                            </a>
                                        </button>
                                    </td>
                                </tr>
                                <tr>
                                    <td style={{ textAlign: "center" }}>6</td>
                                    <td>
                                        {" "}
                                        Skill development course (Fundamental of - Computer and IT/ CAD
                                        and CAM/ Geographical Information System)
                                    </td>
                                    <td style={{ textAlign: "center" }} align="center" valign="middle">
                                        <button className="btn btn-primary btn-download">
                                            <a
                                                className=" float-none"
                                                href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/syllabus-nep/geography-skill-dev.pdf"
                                                target="_blank"
                                                rel="noreferrer"
                                            >
                                                Download
                                            </a>
                                        </button>
                                    </td>
                                </tr>
                                <tr>
                                    <td style={{ textAlign: "center" }}>7</td>
                                    <td>Skill development course (Patrakarita)</td>
                                    <td style={{ textAlign: "center" }} align="center" valign="middle">
                                        <button className="btn btn-primary btn-download">
                                            <a
                                                className=" float-none"
                                                href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/syllabus-nep/Patrakarit-skill-dov-Hindi.pdf"
                                                target="_blank"
                                                rel="noreferrer"
                                            >
                                                Download
                                            </a>
                                        </button>
                                    </td>
                                </tr>
                                <tr>
                                    <td style={{ textAlign: "center" }}>8</td>
                                    <td>Skill development course on (The Apparel Designing)</td>
                                    <td style={{ textAlign: "center" }} valign="middle" align="center">
                                        <button className="btn btn-primary btn-download">
                                            <a
                                                className=" float-none"
                                                href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/syllabus-nep/Apparel-Designing-History-Dept.pdf"
                                                target="_blank"
                                                rel="noreferrer"
                                            >
                                                Download
                                            </a>
                                        </button>
                                    </td>
                                </tr>
                                <tr>
                                    <td style={{ textAlign: "center" }}>9</td>
                                    <td>Skill development course on (Book Publication Course)</td>
                                    <td style={{ textAlign: "center" }} valign="middle" align="center">
                                        <button className="btn btn-primary btn-download">
                                            <a
                                                className=" float-none"
                                                href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/syllabus-nep/Book-Publication-Course-History.pdf"
                                                target="_blank"
                                                rel="noreferrer"
                                            >
                                                Download
                                            </a>
                                        </button>
                                    </td>
                                </tr>
                                <tr>
                                    <td style={{ textAlign: "center" }}>10</td>
                                    <td>Skill development course (Food Preservation)</td>
                                    <td style={{ textAlign: "center" }} valign="middle" align="center">
                                        <button className="btn btn-primary btn-download">
                                            <a
                                                className=" float-none"
                                                href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/syllabus-nep/Food-Preservation-Home-Sc.pdf"
                                                target="_blank"
                                                rel="noreferrer"
                                            >
                                                Download
                                            </a>
                                        </button>
                                    </td>
                                </tr>
                                <tr>
                                    <td style={{ textAlign: "center" }}>11</td>
                                    <td>Skill development course (Food Testing And Quality Control)</td>
                                    <td style={{ textAlign: "center" }} align="center" valign="middle">
                                        <button className="btn btn-primary btn-download">
                                            <a
                                                className=" float-none"
                                                href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/syllabus-nep/skill_and_minor_syllabus-CCSU.pdf"
                                                target="_blank"
                                                rel="noreferrer"
                                            >
                                                Download
                                            </a>
                                        </button>
                                    </td>
                                </tr>
                                <tr>
                                    <td style={{ textAlign: "center" }}>12</td>
                                    <td>Skill development course (Instrumental Music - Tabla)</td>
                                    <td style={{ textAlign: "center" }} align="center" valign="middle">
                                        <button className="btn btn-primary btn-download">
                                            <a
                                                className=" float-none"
                                                href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/syllabus-nep/Tabla-Skill-dov.pdf"
                                                target="_blank"
                                                rel="noreferrer"
                                            >
                                                Download
                                            </a>
                                        </button>
                                    </td>
                                </tr>
                                <tr>
                                    <td style={{ textAlign: "center" }}>13</td>
                                    <td>Skill development course (Yoga and Correctives)</td>
                                    <td style={{ textAlign: "center" }} valign="middle" align="center">
                                        <button className="btn btn-primary btn-download">
                                            <a
                                                className=" float-none"
                                                href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/syllabus-nep/Skill-Yoga-Correctives-Phy-Education.pdf"
                                                target="_blank"
                                                rel="noreferrer"
                                            >
                                                Download
                                            </a>
                                        </button>
                                    </td>
                                </tr>
                                <tr>
                                    <td style={{ textAlign: "center" }}>14</td>
                                    <td> Skill development course (Social work)</td>
                                    <td style={{ textAlign: "center" }} valign="middle" align="center">
                                        <button className="btn btn-primary btn-download">
                                            <a
                                                className=" float-none"
                                                href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/syllabus-nep/Social-Work-Political-Science.pdf"
                                                target="_blank"
                                                rel="noreferrer"
                                            >
                                                Download
                                            </a>
                                        </button>
                                    </td>
                                </tr>
                                <tr>
                                    <td style={{ textAlign: "center" }}>15</td>
                                    <td>Skill development course (Ayurveda Upcharya and Panchkarma)</td>
                                    <td style={{ textAlign: "center" }} valign="middle" align="center">
                                        <button className="btn btn-primary btn-download">
                                            <a
                                                className=" float-none"
                                                href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/syllabus-nep/Ayurveda Upcharya and Panchkarma (Sanskrit Dept).pdf"
                                                target="_blank"
                                                rel="noreferrer"
                                            >
                                                Download
                                            </a>
                                        </button>
                                    </td>
                                </tr>
                                <tr>
                                    <td style={{ textAlign: "center" }}>16</td>
                                    <td>Skill development course (Indian Tribal &amp; Folk Art)</td>
                                    <td style={{ textAlign: "center" }} valign="middle" align="center">
                                        <button className="btn btn-primary btn-download">
                                            <a
                                                className=" float-none"
                                                href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/syllabus-nep/Indian-Tribal-Folk-Art-Drawing-Painting.pdf"
                                                target="_blank"
                                                rel="noreferrer"
                                            >
                                                Download
                                            </a>
                                        </button>
                                    </td>
                                </tr>
                                <tr>
                                    <td style={{ textAlign: "center" }}>17</td>
                                    <td>Skill development course (Introduction to Mutual Funds)</td>
                                    <td style={{ textAlign: "center" }} valign="middle" align="center">
                                        <button className="btn btn-primary btn-download">
                                            <a
                                                className=" float-none"
                                                href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/syllabus-nep/NEP-2020_skill-dev-mutual-fund.pdf"
                                                target="_blank"
                                                rel="noreferrer"
                                            >
                                                Download
                                            </a>
                                        </button>
                                    </td>
                                </tr>
                                <tr>
                                    <td style={{ textAlign: "center" }}>18</td>
                                    <td>Skill development course (Introduction to E-Return)</td>
                                    <td style={{ textAlign: "center" }} valign="middle" align="center">
                                        <button className="btn btn-primary btn-download">
                                            <a
                                                className=" float-none"
                                                href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/syllabus-nep/NEP-2020_skill-dev-ereturn.pdf"
                                                target="_blank"
                                                rel="noreferrer"
                                            >
                                                Download
                                            </a>
                                        </button>
                                    </td>
                                </tr>
                                <tr>
                                    <td style={{ textAlign: "center" }}>19</td>
                                    <td>
                                        Skill development course (Introduction to Textile Management)
                                    </td>
                                    <td style={{ textAlign: "center" }} valign="middle" align="center">
                                        <button className="btn btn-primary btn-download">
                                            <a
                                                className=" float-none"
                                                href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/syllabus-nep/NEP-2020_skill-dev-textile-management.pdf"
                                                target="_blank"
                                                rel="noreferrer"
                                            >
                                                Download
                                            </a>
                                        </button>
                                    </td>
                                </tr>
                                <tr>
                                    <td style={{ textAlign: "center" }}>20</td>
                                    <td>Skill development course (Introduction to Share Market)</td>
                                    <td style={{ textAlign: "center" }} valign="middle" align="center">
                                        <button className="btn btn-primary btn-download">
                                            <a
                                                className=" float-none"
                                                href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/syllabus-nep/NEP-2020_skill-dev-share-market.pdf"
                                                target="_blank"
                                                rel="noreferrer"
                                            >
                                                Download
                                            </a>
                                        </button>
                                    </td>
                                </tr>
                                <tr>
                                    <td style={{ textAlign: "center" }}>21</td>
                                    <td>
                                        Skill development course [Zoology (Basic Clinical Techniques)]
                                    </td>
                                    <td style={{ textAlign: "center" }} align="center" valign="middle">
                                        <button className="btn btn-primary btn-download">
                                            <a
                                                className=" float-none"
                                                href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/syllabus-nep/NEP-2020_skill-dev-zoology.pdf"
                                                target="_blank"
                                                rel="noreferrer"
                                            >
                                                Download
                                            </a>
                                        </button>
                                    </td>
                                </tr>
                                <tr>
                                    <td style={{ textAlign: "center" }}>22</td>
                                    <td>
                                        Skill development in Food Preservation, Processing &amp;
                                        Technology-I{" "}
                                    </td>
                                    <td style={{ textAlign: "center" }} align="center" valign="middle">
                                        <button className="btn btn-primary btn-download">
                                            <a
                                                className=" float-none"
                                                href="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/pdf/2024/09/Skill%20Course-%20Ann-VIII%20(A&B).pdf"
                                                target="_blank"
                                                rel="noreferrer"
                                            >
                                                Download
                                            </a>
                                        </button>
                                    </td>
                                </tr>
                                <tr>
                                    <td>&nbsp;</td>
                                    <td>&nbsp;</td>
                                    <td valign="middle" align="center">
                                        &nbsp;
                                    </td>
                                </tr>
                                <tr>
                                    <td style={{ textAlign: "center" }}>23</td>
                                    <td>
                                        <strong>Vocational/ Skill development course: </strong>
                                        <br />
                                    </td>
                                    <td valign="middle" align="center">
                                        &nbsp;
                                    </td>
                                </tr>
                                <tr>
                                    <td>&nbsp;</td>
                                    <td>Communication Skill &amp; Personality Development </td>
                                    <td style={{ textAlign: "center" }} align="center" valign="middle">
                                        <button className="btn btn-primary btn-download">
                                            <a
                                                className=" float-none"
                                                href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/syllabus-nep/skill_personality-dov-communi-skill.pdf"
                                                target="_blank"
                                                rel="noreferrer"
                                            >
                                                Download
                                            </a>
                                        </button>
                                    </td>
                                </tr>
                                <tr>
                                    <td>&nbsp;</td>
                                    <td>Folk Art</td>
                                    <td style={{ textAlign: "center" }} valign="middle" align="center">
                                        <button className="btn btn-primary btn-download">
                                            <a
                                                className=" float-none"
                                                href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/syllabus-nep/skill-dovelopment-folk-art.pdf"
                                                target="_blank"
                                                rel="noreferrer"
                                            >
                                                Download
                                            </a>
                                        </button>
                                    </td>
                                </tr>
                                <tr>
                                    <td>&nbsp;</td>
                                    <td>Heritage Guide</td>
                                    <td style={{ textAlign: "center" }} valign="middle" align="center">
                                        <button className="btn btn-primary btn-download">
                                            <a
                                                className=" float-none"
                                                href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/syllabus-nep/skill-dovelopment-heritage-guide.pdf"
                                                target="_blank"
                                                rel="noreferrer"
                                            >
                                                Download
                                            </a>
                                        </button>
                                    </td>
                                </tr>
                                <tr>
                                    <td>&nbsp;</td>
                                    <td>News Writing and Reporting</td>
                                    <td style={{ textAlign: "center" }} valign="middle" align="center">
                                        <button className="btn btn-primary btn-download">
                                            <a
                                                className=" float-none"
                                                href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/syllabus-nep/skill-dovelopment-news-writing-reporting.pdf"
                                                target="_blank"
                                                rel="noreferrer"
                                            >
                                                Download
                                            </a>
                                        </button>
                                    </td>
                                </tr>
                                <tr>
                                    <td>&nbsp;</td>
                                    <td> Retail Management</td>
                                    <td style={{ textAlign: "center" }} valign="middle" align="center">
                                        <button className="btn btn-primary btn-download">
                                            <a
                                                className=" float-none"
                                                href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/syllabus-nep/skill-dovelopment-retail-management.pdf"
                                                target="_blank"
                                                rel="noreferrer"
                                            >
                                                Download
                                            </a>
                                        </button>
                                    </td>
                                </tr>
                                <tr>
                                    <td>&nbsp;</td>
                                    <td>Sports Engineering</td>
                                    <td style={{ textAlign: "center" }} valign="middle" align="center">
                                        <button className="btn btn-primary btn-download">
                                            <a
                                                className=" float-none"
                                                href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/syllabus-nep/skill-dovelopment-news-sports-engineerig.pdf"
                                                target="_blank"
                                                rel="noreferrer"
                                            >
                                                Download
                                            </a>
                                        </button>
                                    </td>
                                </tr>
                                <tr>
                                    <td>.</td>
                                    <td>Computerized Accounting &amp; GST</td>
                                    <td style={{ textAlign: "center" }} valign="middle" align="center">
                                        <button className="btn btn-primary btn-download">
                                            <a
                                                className=" float-none"
                                                href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/syllabus-nep/skill_computer-account-gst.pdf"
                                                target="_blank"
                                                rel="noreferrer"
                                            >
                                                Download
                                            </a>
                                        </button>
                                    </td>
                                </tr>
                                <tr>
                                    <td>&nbsp;</td>
                                    <td>Foundation Course in Digital Marketing</td>
                                    <td style={{ textAlign: "center" }} valign="middle" align="center">
                                        <button className="btn btn-primary btn-download">
                                            <a
                                                className=" float-none"
                                                href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/syllabus-nep/skill_digital-marketing.pdf"
                                                target="_blank"
                                                rel="noreferrer"
                                            >
                                                Download
                                            </a>
                                        </button>
                                    </td>
                                </tr>
                                <tr>
                                    <td>&nbsp;</td>
                                    <td>Web Designing</td>
                                    <td style={{ textAlign: "center" }} valign="middle" align="center">
                                        <button className="btn btn-primary btn-download">
                                            <a
                                                className=" float-none"
                                                href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/syllabus-nep/skill_web-designing.pdf"
                                                target="_blank"
                                                rel="noreferrer"
                                            >
                                                Download
                                            </a>
                                        </button>
                                    </td>
                                </tr>
                                <tr>
                                    <td>&nbsp;</td>
                                    <td>Applied Research (Political Science)</td>
                                    <td style={{ textAlign: "center" }} valign="middle" align="center">
                                        <button className="btn btn-primary btn-download">
                                            <a
                                                className=" float-none"
                                                href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/syllabus-nep/skill_Applied-Research-polti-sci.pdf"
                                                target="_blank"
                                                rel="noreferrer"
                                            >
                                                Download
                                            </a>
                                        </button>
                                    </td>
                                </tr>
                                <tr>
                                    <td>&nbsp;</td>
                                    <td>Yoga (Physical Education)</td>
                                    <td style={{ textAlign: "center" }} valign="middle" align="center">
                                        <button className="btn btn-primary btn-download">
                                            <a
                                                className=" float-none"
                                                href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/syllabus-nep/skill_yoga-physical-edu.pdf"
                                                target="_blank"
                                                rel="noreferrer"
                                            >
                                                Download
                                            </a>
                                        </button>
                                    </td>
                                </tr>
                                <tr>
                                    <td>&nbsp;</td>
                                    <td>Functional Hindi (Political Science)</td>
                                    <td style={{ textAlign: "center" }} valign="middle" align="center">
                                        <button className="btn btn-primary btn-download">
                                            <a
                                                className=" float-none"
                                                href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/syllabus-nep/skill_functional-hindi-polti-sci.pdf"
                                                target="_blank"
                                                rel="noreferrer"
                                            >
                                                Download
                                            </a>
                                        </button>
                                    </td>
                                </tr>
                                <tr>
                                    <td>&nbsp;</td>
                                    <td>Organic Framing (Chemistry)</td>
                                    <td style={{ textAlign: "center" }} valign="middle" align="center">
                                        <button className="btn btn-primary btn-download">
                                            <a
                                                className=" float-none"
                                                href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/syllabus-nep/skill_Organic-Framing-Chemistry.pdf"
                                                target="_blank"
                                                rel="noreferrer"
                                            >
                                                Download
                                            </a>
                                        </button>
                                    </td>
                                </tr>
                                <tr>
                                    <td>&nbsp;</td>
                                    <td>&nbsp;</td>
                                    <td valign="middle" align="center">
                                        &nbsp;
                                    </td>
                                </tr>
                                <tr>
                                    <td>&nbsp;</td>
                                    <td>
                                        <strong>
                                            Vocational Studies- Skill Development Course Certificate
                                        </strong>
                                    </td>
                                    <td valign="middle" align="center">
                                        &nbsp;
                                    </td>
                                </tr>
                                <tr>
                                    <td style={{ textAlign: "center" }}>24</td>
                                    <td>Basic Certificate in Airport Operations</td>
                                    <td style={{ textAlign: "center" }} align="center" valign="middle">
                                        <button className="btn btn-primary btn-download">
                                            <a
                                                className="float-none"
                                                href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/syllabus-nep/skill_Certi-Airport-Operations-Voc-Studies-N.pdf"
                                                target="_blank"
                                                rel="noreferrer"
                                            >
                                                Download
                                            </a>
                                        </button>
                                    </td>
                                </tr>
                                <tr>
                                    <td style={{ textAlign: "center" }}>25</td>
                                    <td>Basic Certificate in Cabin Crew</td>
                                    <td style={{ textAlign: "center" }} align="center" valign="middle">
                                        <button className="btn btn-primary btn-download">
                                            <a
                                                className="float-none"
                                                href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/syllabus-nep/skill_Certifi-Cabin-Crew-Voc-Studies-N.pdf"
                                                target="_blank"
                                                rel="noreferrer"
                                            >
                                                Download
                                            </a>
                                        </button>
                                    </td>
                                </tr>
                                <tr>
                                    <td style={{ textAlign: "center" }}>26</td>
                                    <td>Basic Certificate in Fundamentals of Science Laboratory</td>
                                    <td style={{ textAlign: "center" }} align="center" valign="middle">
                                        <button className="btn btn-primary btn-download">
                                            <a
                                                className="float-none"
                                                href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/syllabus-nep/Certi-Funda-sci-Lab-Voc-Studies.pdf"
                                                target="_blank"
                                                rel="noreferrer"
                                            >
                                                Download
                                            </a>
                                        </button>
                                    </td>
                                </tr>
                                <tr>
                                    <td style={{ textAlign: "center" }}>27</td>
                                    <td>Basic Certificate in Itinerary Development</td>
                                    <td style={{ textAlign: "center" }} align="center" valign="middle">
                                        <button className="btn btn-primary btn-download">
                                            <a
                                                className="float-none"
                                                href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/syllabus-nep/Certi-Itinerary-Voc-Studies.pdf"
                                                target="_blank"
                                                rel="noreferrer"
                                            >
                                                Download
                                            </a>
                                        </button>
                                    </td>
                                </tr>
                                <tr>
                                    <td style={{ textAlign: "center" }}>28</td>
                                    <td>Basic Certificate in Medical Laboratory</td>
                                    <td style={{ textAlign: "center" }} align="center" valign="middle">
                                        <button className="btn btn-primary btn-download">
                                            <a
                                                className="float-none"
                                                href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/syllabus-nep/Certi-Medical-Labor-Voc-Studies.pdf"
                                                target="_blank"
                                                rel="noreferrer"
                                            >
                                                Download
                                            </a>
                                        </button>
                                    </td>
                                </tr>
                                <tr>
                                    <td style={{ textAlign: "center" }}>29</td>
                                    <td>Basic Certificate in Travel Agency and Tour Operations</td>
                                    <td style={{ textAlign: "center" }} align="center" valign="middle">
                                        <button className="btn btn-primary btn-download">
                                            <a
                                                className="float-none"
                                                href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/syllabus-nep/skill_Certi-Travel-Agency-and-tour-Operations-Voc-Studies-N.pdf"
                                                target="_blank"
                                                rel="noreferrer"
                                            >
                                                Download
                                            </a>
                                        </button>
                                    </td>
                                </tr>
                                <tr>
                                    <td style={{ textAlign: "center" }}>30</td>
                                    <td>
                                        Certificate in Application of different techniques in Biological
                                        Sciences
                                    </td>
                                    <td style={{ textAlign: "center" }} align="center" valign="middle">
                                        <button className="btn btn-primary btn-download">
                                            <a
                                                className="float-none"
                                                href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/syllabus-nep/Certi-Appli-diff-tech-bio-sci-Voc-Studies.pdf"
                                                target="_blank"
                                                rel="noreferrer"
                                            >
                                                Download
                                            </a>
                                        </button>
                                    </td>
                                </tr>
                                <tr>
                                    <td style={{ textAlign: "center" }}>31</td>
                                    <td>
                                        Certificate in Basics of Biochemical and Microbiological
                                        Laboratory Techniques
                                    </td>
                                    <td style={{ textAlign: "center" }} align="center" valign="middle">
                                        <button className="btn btn-primary btn-download">
                                            <a
                                                className="float-none"
                                                href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/syllabus-nep/Certi-Biochemical-micro-labor-tech-Voc-Studies.pdf"
                                                target="_blank"
                                                rel="noreferrer"
                                            >
                                                Download
                                            </a>
                                        </button>
                                    </td>
                                </tr>
                                <tr>
                                    <td style={{ textAlign: "center" }}>32</td>
                                    <td>Certificate Course in Organic Farming</td>
                                    <td style={{ textAlign: "center" }} align="center" valign="middle">
                                        <button className="btn btn-primary btn-download">
                                            <a
                                                className="float-none"
                                                href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/syllabus-nep/skill-dovelopment-organic-farming.pdf"
                                                target="_blank"
                                                rel="noreferrer"
                                            >
                                                Download
                                            </a>
                                        </button>
                                    </td>
                                </tr>
                                <tr>
                                    <td style={{ textAlign: "center" }}>33</td>
                                    <td>Basic Certificate in MIS (Management Information System)</td>
                                    <td style={{ textAlign: "center" }} align="center" valign="middle">
                                        <button className="btn btn-primary btn-download">
                                            <a
                                                className="float-none"
                                                href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/syllabus-nep/skill_mis.pdf"
                                                target="_blank"
                                                rel="noreferrer"
                                            >
                                                Download
                                            </a>
                                        </button>
                                    </td>
                                </tr>
                                <tr>
                                    <td>&nbsp;</td>
                                    <td>&nbsp;</td>
                                    <td valign="middle" align="center">
                                        &nbsp;
                                    </td>
                                </tr>
                                <tr>
                                    <td>&nbsp;</td>
                                    <td>
                                        <strong>
                                            Certificate course in Biomusicology (Music Therapy)
                                        </strong>
                                    </td>
                                    <td style={{ textAlign: "center" }} valign="middle" align="center">
                                        &nbsp;
                                    </td>
                                </tr>
                                <tr>
                                    <td style={{ textAlign: "center" }}>34</td>
                                    <td>
                                        Certificate course in Biomusicology (Music Therapy): Level-1
                                    </td>
                                    <td style={{ textAlign: "center" }} align="center" valign="middle">
                                        <button className="btn btn-primary btn-download">
                                            <a
                                                className="float-none"
                                                href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/syllabus-nep/Biomusicology-Level-1-zoology.pdf"
                                                target="_blank"
                                                rel="noreferrer"
                                            >
                                                Download
                                            </a>
                                        </button>
                                    </td>
                                </tr>
                                <tr>
                                    <td style={{ textAlign: "center" }}>35</td>
                                    <td>
                                        Certificate course in Biomusicology (Music Therapy): Level-2
                                    </td>
                                    <td style={{ textAlign: "center" }} align="center" valign="middle">
                                        <button className="btn btn-primary btn-download">
                                            <a
                                                className="float-none"
                                                href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/syllabus-nep/Biomusicology-Level-2-zoology.pdf"
                                                target="_blank"
                                                rel="noreferrer"
                                            >
                                                Download
                                            </a>
                                        </button>
                                    </td>
                                </tr>
                                <tr>
                                    <td style={{ textAlign: "center" }}>36</td>
                                    <td>
                                        Certificate course in Biomusicology (Music Therapy): Level-3
                                    </td>
                                    <td style={{ textAlign: "center" }} align="center" valign="middle">
                                        <button className="btn btn-primary btn-download">
                                            <a
                                                className="float-none"
                                                href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/syllabus-nep/Biomusicology-Level-3-zoology.pdf"
                                                target="_blank"
                                                rel="noreferrer"
                                            >
                                                Download
                                            </a>
                                        </button>
                                    </td>
                                </tr>
                                <tr>
                                    <td style={{ textAlign: "center" }}>37</td>
                                    <td>
                                        Certificate course in Biomusicology (Music Therapy): Level-4
                                    </td>
                                    <td style={{ textAlign: "center" }} align="center" valign="middle">
                                        <button className="btn btn-primary btn-download">
                                            <a
                                                className="float-none"
                                                href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/syllabus-nep/Biomusicology-Level-4-zoology.pdf"
                                                target="_blank"
                                                rel="noreferrer"
                                            >
                                                Download
                                            </a>
                                        </button>
                                    </td>
                                </tr>
                                <tr>
                                    <td>&nbsp;</td>
                                    <td>&nbsp;</td>
                                    <td valign="middle" align="center">
                                        &nbsp;
                                    </td>
                                </tr>
                                <tr>
                                    <td>&nbsp;</td>
                                    <td>
                                        <strong>Co-Curricular Course (Updated on 22-12-23)</strong>
                                    </td>
                                    <td valign="middle" align="center">
                                        &nbsp;
                                    </td>
                                </tr>
                                <tr>
                                    <td style={{ textAlign: "center" }}>38</td>
                                    <td>Food, Nutrition and Hygiene : Semester - 1</td>
                                    <td style={{ textAlign: "center" }} align="center" valign="middle">
                                        <button className="btn btn-primary btn-download">
                                            <a
                                                className="float-none"
                                                href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/syllabus-nep/Cultural-Course-Sem-1.pdf"
                                                target="_blank"
                                                rel="noreferrer"
                                            >
                                                Download
                                            </a>
                                        </button>
                                    </td>
                                </tr>
                                <tr>
                                    <td style={{ textAlign: "center" }}>39</td>
                                    <td>First Aid and Health : Semester- 2</td>
                                    <td style={{ textAlign: "center" }} align="center" valign="middle">
                                        <button className="btn btn-primary btn-download">
                                            <a
                                                className="float-none"
                                                href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/syllabus-nep/Cultural-Course-Sem-2.pdf"
                                                target="_blank"
                                                rel="noreferrer"
                                            >
                                                Download
                                            </a>
                                        </button>
                                    </td>
                                </tr>
                                <tr>
                                    <td style={{ textAlign: "center" }}>40</td>
                                    <td>Human Values and Environment studies : Semester - 3</td>
                                    <td style={{ textAlign: "center" }} align="center" valign="middle">
                                        <button className="btn btn-primary btn-download">
                                            <a
                                                className="float-none"
                                                href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/syllabus-nep/Cultural-Course-Sem-3.pdf"
                                                target="_blank"
                                                rel="noreferrer"
                                            >
                                                Download
                                            </a>
                                        </button>
                                    </td>
                                </tr>
                                <tr>
                                    <td style={{ textAlign: "center" }}>41</td>
                                    <td>Physical Education and Yoga : Semester - 4</td>
                                    <td style={{ textAlign: "center" }} align="center" valign="middle">
                                        <button className="btn btn-primary btn-download">
                                            <a
                                                className="float-none"
                                                href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/syllabus-nep/Cultural-Course-Sem-4.pdf"
                                                target="_blank"
                                                rel="noreferrer"
                                            >
                                                Download
                                            </a>
                                        </button>
                                    </td>
                                </tr>
                                <tr>
                                    <td style={{ textAlign: "center" }}>42</td>
                                    <td>Analytic Ability and Digital Awareness : Semester - 5</td>
                                    <td style={{ textAlign: "center" }} align="center" valign="middle">
                                        <button className="btn btn-primary btn-download">
                                            <a
                                                className="float-none"
                                                href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/syllabus-nep/Cultural-Course-Sem-5.pdf"
                                                target="_blank"
                                                rel="noreferrer"
                                            >
                                                Download
                                            </a>
                                        </button>
                                    </td>
                                </tr>
                                <tr>
                                    <td style={{ textAlign: "center" }}>43</td>
                                    <td>
                                        Communication Skills and Personality Development : Semester - 6
                                    </td>
                                    <td style={{ textAlign: "center" }} align="center" valign="middle">
                                        <button className="btn btn-primary btn-download">
                                            <a
                                                className="float-none"
                                                href="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/syllabus-nep/Cultural-Course-Sem-6.pdf"
                                                target="_blank"
                                                rel="noreferrer"
                                            >
                                                Download
                                            </a>
                                        </button>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </section>

        </div>
    )
}

export default Main;